import AnimationController from './animation-controller.js';

let canvas = document.getElementById('canvas');
let context = canvas.getContext('2d');

let scale = 1;
let centerX = 250;
let centerY = 250;

let controller;

function init() {
	controller = new AnimationController();

	handleResize();
	// Set up event listeners.
	window.addEventListener('resize', handleResize);
	// Kick off the update loop
	window.requestAnimationFrame(everyFrame);
}

function everyFrame() {
	update();
	render();
	requestAnimationFrame(everyFrame);
}

function update() {
	controller.update();
}

function render() {
	context.clearRect(0, 0, canvas.width, canvas.height);

	controller.render(context, centerX, centerY, scale);
}

function handleResize(evt) {
	canvas.width = window.innerWidth;
	canvas.height = window.innerHeight;

	scale = Math.min(canvas.width, canvas.height) / 500;
	centerX = 0.66 * canvas.width / scale;
	centerY = 0.5 * canvas.height / scale;

	render();
}

init();


// WEBPACK FOOTER //
// ./js/main.js